// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.show-jobs .v-menu__content.preferred-contact-menu.preferred-contact-menu {
  z-index: 205 !important;
}
.v-menu__content.preferred-contact-menu.preferred-contact-menu {
  z-index: 201 !important;
}
.jobview .main-inner-content {
  padding-bottom: 0;
}
.jobview-show .fullScreen {
  z-index: 203 !important;
  height: calc(100% - 65px) !important;
  top: 65px;
}
.jobview-show .fullScreenIcon {
  z-index: 204 !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
